import React, {Component} from "react";
import Button from "../button/Button";

export default class ButtonTop extends Component {

    constructor(props) {
        super(props)
        this.onClick = this.onClick.bind(this)
    }

    onClick() {
        window.scrollTo({top: 0, behavior: 'smooth'});
    }

    render() {
        return (
            <div>
                <Button onClick={this.onClick} id={"button"}
                        style={{
                            cursor: "pointer",
                            outline: "none",
                            border: "none",
                            position: "fixed",
                            bottom: "0",
                            right: "",
                            zIndex: "99",
                            background: "none"
                        }}
                        class="btn btn-primary"
                        title={"Torna all'inizio"}
                        icon={<svg width="3em" height="3em" viewBox="0 0 16 16" className="bi bi-arrow-up-circle-fill"
                                   fill="#1B7EA9">
                            <path fillRule="evenodd"
                                  d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-10.646.354a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 6.207V11a.5.5 0 0 1-1 0V6.207L5.354 8.354z"/>
                        </svg>}
                />
            </div>
        )
    }
}
